import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { getNextPageIndex, pageRange } from "../../../utils/pagination";
import { keys } from "./keys";
import { _3_DAYS } from "../../../constants/durations";
import { formatISO, startOfDay } from "date-fns";

const PAGE_SIZE = 10;

async function fetchUpcomingReminders(spaceId: string, pageIndex: number) {
  const today = formatISO(startOfDay(new Date()), { representation: 'date' });
  const { from, to } = pageRange(pageIndex, PAGE_SIZE);

  const { data, error } = await apiClient
    .from('reminders')
    .select()
    .eq('space_id', spaceId)
    .eq('is_completed', false)
    .gte('due_date', today)
    .order('due_date', { ascending: true })
    .order('id', { ascending: true })
    .range(from, to);

  if (error) {
    throw error;
  }

  return data;
}

type Options = {
  enabled?: boolean;
};

export default function useGetUpcomingReminders(options?: Options) {
  const { currentSpace } = useSpace();

  return useInfiniteQuery({
    queryKey: keys.upcoming(currentSpace?.id ?? ''),
    queryFn: ({ pageParam }) => fetchUpcomingReminders(currentSpace!.id, pageParam),
    initialPageParam: 0,
    getNextPageParam: getNextPageIndex(PAGE_SIZE),
    enabled: (options?.enabled ?? true) && !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
